import React from "react";
import { useTranslation } from "react-i18next";
import "./CSS/QueueListComponent.css";
import { Spinner } from "@fluentui/react-components";
const QueueListComponent = ({ queues, queueKpis }) => {
  const { t } = useTranslation();
console.log("Rendering QueueListComponent with queues:", queues , "and queueKpis:", queueKpis);
  // Fonction pour formater les pourcentages
  const formatPercentage = (value) => {
    if (value == null || value === "--" || value === 0) return "0%";
    const numberValue = parseFloat(value);
    return `${Math.round(numberValue)}%`;
  };

  // Fonction pour déterminer la couleur selon le temps d'attente
  const getWaitTimeColor = (timeString) => {
    if (!timeString || timeString === "00:00:00") return "#94a3b8";

    // Parser le temps HH:MM:SS
    const parts = timeString.split(":");
    const hours = parseInt(parts[0] || 0);
    const minutes = parseInt(parts[1] || 0);
    const seconds = parseInt(parts[2] || 0);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    // Orange si < 1 min, vert si < 2 min, bleu sinon
    if (totalSeconds < 60) return "#fbbf24"; // Orange/jaune
    if (totalSeconds < 120) return "#10b981"; // Vert
    return "#6366f1"; // Bleu
  };

  return (
    <div className="queue-list-container">
      <div className="queue-list-header drag-handle">
        <button className="kpi-card-menu">⋮⋮</button>
        <h3>{t("REALTIME.WAITING_QUEUE")}</h3>
        <span className="queue-count">{queues.length}</span>

      </div>

      <div className="queue-table-wrapper">
        {queues.length === 0 || Object.keys(queueKpis).length === 0 ? (
          <div className="no-data">{t("REALTIME.NO_QUEUE_DATA")}</div>

        ) : (
          <table className="queue-table">
            <thead>
              <tr>

                <th>{t("REALTIME.CALLS_IN_QUEUE")}</th>
                <th>{t("REALTIME.LIVE_CALLS")}</th>
                <th>{t("REALTIME.READY_AGENTS")}</th>
                <th>{t("REALTIME.SERVICE_LEVEL")}</th>
                {/*} 
              <th>{t("REALTIME.MAX_WAIT_TIME")}</th>
              <th>{t("REALTIME.OVERFLOW")}</th>*/}
                <th>{t("REALTIME.SLA")}</th>
                <th>{t("REALTIME.QUEUE_NAME_SINGULAR")}</th>
              </tr>
            </thead>
            <tbody>
              {queues.map((queue) => {
                const queueId = queue.id || queue.RowKey;
                const kpi = queueKpis[queueId];

                if (!kpi) return null;

                const queueName = queue.queueName || queue.name;
                const queueSla = kpi.sla || 0;
                const slaThreshold = queue.slaThreshold || 80;
                const slaColor =
                  queueSla > slaThreshold
                    ? "linear-gradient(180deg, rgba(16, 185, 129, 0.75) 0%, rgba(5, 150, 105, 0.85) 100%)"
                    : "linear-gradient(180deg, rgba(251, 113, 133, 0.7) 0%, rgba(244, 63, 94, 0.75) 100%)";
                const rowBackgroundColor = queueSla > slaThreshold ? "#d1fae5" : "#fee2e2";
                return (
                  <tr key={queueId} style={{ backgroundColor: rowBackgroundColor }}>

                    <td>
                      <span>{kpi.todayCalls || 0}</span>
                    </td>
                    <td>
                      <span>{kpi.callsInQueue || 0}</span>
                    </td>
                    <td>
                      <span>{kpi.agentsReady || 0}</span>
                    </td>
                    <td>
                      <span>{formatPercentage(kpi.sla)}</span>
                    </td>
                    {/*
                  <td>
                    <span>{kpi.maxWaitTime || "00:00:00"}</span>
                  </td>
                  <td>
                    <span>{formatPercentage(kpi.overflowRate)}</span>
                  </td>*/}
                    <td>
                      <div className="kpi-cell">
                        <div
                          className="kpi-indicator"
                          style={{ background: slaColor }}
                        />
                      </div>
                    </td>
                    <td className="queue-name-cell">{queueName}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default QueueListComponent;
